<script setup lang="ts">
import type { Customer } from '@/types'
import { Head, Link } from '@inertiajs/vue3'
import CustomerForm from '@/components/customers/CustomerForm.vue'
import { dashboardLayout } from '@/lib/layouts'
import { adminCustomersPath } from '@/routes'

defineOptions({
  layout: dashboardLayout,
})

defineProps<{
  customer: Partial<Customer>
}>()

const title = 'New customer'
</script>

<template>
  <Head :title="title" />

  <UDashboardPanel id="customer-new">
    <template #header>
      <UDashboardNavbar :title="title">
        <template #leading>
          <UButton
            :to="adminCustomersPath()"
            :as="Link"
            icon="i-lucide-arrow-left"
            color="neutral"
            variant="ghost"
            square
          />
        </template>
      </UDashboardNavbar>
    </template>

    <template #body>
      <CustomerForm
        :customer="customer"
        :action="adminCustomersPath()"
        method="post"
        submit-label="Create customer"
      />
    </template>
  </UDashboardPanel>
</template>
